// Juli's display order. Many pieces share an order value, so break ties by id
// to keep the same order between visits.
export const byShopOrder = (a, b) => (a.order - b.order) || (a.id - b.id);

// 'bowls' -> 'Bowls'
export const typeLabel = (type) => (type ? type.charAt(0).toUpperCase() + type.slice(1) : '');

// The shop's piece types with counts, most pieces first: [{ value: 'bowls', label: 'Bowls', count: 12 }, ...]
export const shopTypes = (items) => {
    const counts = {};
    items.forEach((item) => { counts[item.product_type] = (counts[item.product_type] || 0) + 1; });
    return Object.entries(counts)
        .map(([value, count]) => ({ value, label: typeLabel(value), count }))
        .sort((a, b) => (b.count - a.count) || a.label.localeCompare(b.label));
};

export const shopTypeUrl = (type) => `/shop/main?type=${encodeURIComponent(type)}`;
